import { render, staticRenderFns } from "./TheVsMDView.vue?vue&type=template&id=da2c89f2&"
import script from "./TheVsMDView.vue?vue&type=script&lang=js&"
export * from "./TheVsMDView.vue?vue&type=script&lang=js&"
import style0 from "./TheVsMDView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports